import { Pipe, PipeTransform } from '@angular/core';
import username from '../helpers/validationMessages/username';
import password from '../helpers/validationMessages/password';
import email from '../helpers/validationMessages/email';
import firstname from '../helpers/validationMessages/firstname';
import lastname from '../helpers/validationMessages/lastname';
import age from '../helpers/validationMessages/age';
import amka from '../helpers/validationMessages/amka';
import facility from '../helpers/validationMessages/facility';
import sensorID from '../helpers/validationMessages/sensor-id'
import sensorLat from '../helpers/validationMessages/sensorLat'
import sensorLng from '../helpers/validationMessages/sensorLng'
import sensorSlot from '../helpers/validationMessages/sensorSlot'
import latitude from '../helpers/validationMessages/latitude'
import longitude from '../helpers/validationMessages/longitude';

@Pipe({
  name: 'inputError'
})
export class FormInputErrorPipe implements PipeTransform {

  transform(value: any): string {
    let rvalue: string = '';
    switch (value) {
      case latitude.latitude[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LATITUDE_REQ'
      case latitude.latitude[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LATITUDE_MAX_CHAR'
      case latitude.latitude[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LATITUDE_MIN_CHAR'
      case latitude.latitude[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LATITUDE_WRONG'
      case longitude.longitude[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LONGITUDE_REQ'
      case longitude.longitude[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LONGITUDE_MAX_CHAR'
      case longitude.longitude[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LONGITUDE_MIN_CHAR'
      case longitude.longitude[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LONGITUDE_WRONG'
      // Cases of usernames
      case username.username[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_REQ'
      case username.username[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_MIN_CHAR'
      case username.username[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_MAX_CHAR'
      case username.username[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_NUM_LETTERS'
      case username.username[4].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_TAKEN'
      case username.username[5].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_USERNAME_WRONG'
      // Cases of passwords
      case password.password[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_PASS_REQ'
      case password.password[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_PASS_MIN_CHAR'
      case password.password[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_PASS_NUM_LETTERS'
      case password.password[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_PASS__WRONG'
      // Cases of firstname
      case firstname.firstname[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_FIRSTNAME_REQ'
      case firstname.firstname[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_FIRSTNAME_MIN_CHAR'
      case firstname.firstname[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_FIRSTNAME_MAX_CHAR'
      case firstname.firstname[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_FIRSTNAME_PATTERN'
      // Cases of lastname
      case lastname.lastname[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LASTNAME_REQ'
      case lastname.lastname[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LASTNAME_MIN_CHAR'
      case lastname.lastname[2].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LASTNAME_MAX_CHAR'
      case lastname.lastname[3].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_LASTNAME_PATTERN'
      // Cases of email
      case email.email[0].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_EMAIL_REQ'
      case email.email[1].message:
        return rvalue = 'LOGIN.ERRORS.ERROR_EMAIL_WRONG'
      // Cases of facility
      case facility.facility[0].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_FACILITY_REQ'
      case facility.facility[1].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_FACILITY_MIN_CHAR'
      case facility.facility[2].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_FACILITY_MAX_CHAR'
      case facility.facility[3].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_FACILITY_PATTERN'
      // Cases of age
      case age.age[0].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AGE_REQ'
      case age.age[1].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AGE_PATTERN'
      // Cases of AMKA
      case amka.amka[0].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AMKA_REQ'
      case amka.amka[1].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AMKA_MIN_CHAR'
      case amka.amka[2].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AMKA_MAX_CHAR'
      case amka.amka[3].message:
        return rvalue = 'PATIENT_DETAILS.ERRORS.ERROR_AMKA_PATTERN'
      case sensorID.sensorID[0].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_ID_REQ'
      case sensorID.sensorID[1].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_PATTERN'
      case sensorLat.sensorLat[0].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LAT_REQ'
      case sensorLat.sensorLat[1].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LAT_PATTERN'
      case sensorLat.sensorLat[2].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_MIN_CHAR'
      case sensorLat.sensorLat[3].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_MAX_CHAR'
      case sensorLng.sensorLng[0].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LNG_REQ'
      case sensorLng.sensorLng[1].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LNG_PATTERN'
      case sensorLng.sensorLng[2].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LNG_MIN_CHAR'
      case sensorLng.sensorLng[3].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_LNG_MAX_CHAR'
      case sensorSlot.sensorSlot[0].message:
        return rvalue = 'SENSORS.ERRORS.SENSOR_SLOT_MAX_CHAR'
      default:
        return rvalue;
    }
  }

}
